import { render, staticRenderFns } from "./Chamada.vue?vue&type=template&id=1325a506&scoped=true&"
import script from "./Chamada.vue?vue&type=script&lang=js&"
export * from "./Chamada.vue?vue&type=script&lang=js&"
import style0 from "./Chamada.vue?vue&type=style&index=0&id=1325a506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325a506",
  null
  
)

export default component.exports